import { Component, OnInit } from '@angular/core';
import { HorizontalListData } from 'common';
import { AccountBreakdown, AccountOnboarding } from '../../account/account.model';
import { AccountService } from '../../account/account.service';
import { routerTransition } from '../../shared/animations/router.animations';
import { SalesDashboardAdapter } from './sales-dashboard.data';

@Component({
    selector: 'ifb-sales-dashboard',
    templateUrl: './sales-dashboard.component.html',
    styleUrls: ['./sales-dashboard.component.scss'],
    providers: [SalesDashboardAdapter],
    animations: routerTransition,
    standalone: false
})
export class SalesDashboardComponent implements OnInit {
  accountOnboardingListData: HorizontalListData[];
  accountBreakdownListData: HorizontalListData[];

  constructor(
    private readonly accountService: AccountService,
    private readonly adapter: SalesDashboardAdapter
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  private initData(): void {
    this.accountService.onboardingInfo()
      .subscribe((data: AccountOnboarding) => {
        this.accountOnboardingListData = this.adapter.adaptAccountOnboardingListData(data);
      });
    this.accountService.breakdownInfo()
      .subscribe((data: AccountBreakdown) => {
        this.accountBreakdownListData = this.adapter.adaptAccountBreakdownListData(data);
      });
  }
}
